module.exports = __webpack_public_path__ + "static/GT-Haptik-Bold-aa3fc1b5d4464972c0b3ab0160ef42d9.woff2";